'use client';
import ResetPassword from '@components/Auth/ResetPassword';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

const ResetPasswordView = () => {
  const { push } = useCurrentUrl();

  return (
    <div className="p-6 sm:px-16 sm:pt-14 sm:pb-8 max-w-2xl mx-auto">
      <h4 className="tra-text-web-heading-4 w-full mb-6 sm:mb-8">Reset Password</h4>
      <ResetPassword onSuccess={() => push('/account')} />
    </div>
  );
};

export default ResetPasswordView;
